import path from '@/api/index'
import { axios } from '@/utils/request'

// 根据类型获取数据字典
export function getDictByType (typeValue) {
  return axios({
    url: path.sys + '/dict/getByType',
    method: 'POST',
    data: { 'type': typeValue }
  })
}

// 获取当前账号的身份数据集合
export function getRole () {
  return axios({
    url: path.sys + '/user/getRole',
    method: 'GET'
  })
}

/**
 * 根据value过滤出对应的label值
 * @param dictList 候选数据
 * @param value value值
 * @returns {string}
 */
export function filterLabelName (dictList, value) {
  if (dictList.length === 0 || !value) return '';
  return dictList.some(i => i.value === value) ? dictList.filter(i => i.value === value)[0].label : ''
}

// 数据字典转换成选择框数据 label:dictKey   value:dictValue
export function conversionDict (res) {
  let dict = []
  if (res.code === 10000) {
    dict = res.result.map(item => {
      return { label: item.dictKey, value: item.dictValue }
    })
  }
  return dict
}

